import { ReactNode } from "react";

import { Box } from "@mui/material";

import { FieldInfo } from "../field-info/FieldInfo";

interface Props {
  fieldLabel: string;
  info?: string;
  infoContent?: ReactNode;
  children: ReactNode;
}

export function FieldWithInfo({ fieldLabel, info, infoContent, children }: Props) {
  return (
    <Box display="flex" alignItems="start" gap={0.5}>
      <Box flex={1} minWidth={0}>
        {children}
      </Box>
      <FieldInfo fieldLabel={fieldLabel} text={info}>
        {infoContent}
      </FieldInfo>
    </Box>
  );
}
